import React, { useEffect, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { investorApi, vendorApi, api } from "../api/api";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../components/common/Loader";
 
import ScreenContainer from "../components/common/screencontainer";
import ApartmentLayoutPage from "../components/ApartmentPlots/ApartmentLayoutPage";
import AprtmentPlotsDetails from "../components/ApartmentPlots/AprtmentPlotsDetalis";
import AprtmentPlotsOverview from "../components/ApartmentPlots/AprtmentPlotsOverView";
import { useParams, useSearchParams } from "react-router-dom";
 
 
// import LoginModal from "../components/common/LoginModal";
 
const SECRET_KEY = "yourSecretKey";
 
const ApartmentPlotsScreen = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
 
  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  const location = useLocation();
  const { slug } = useParams();
const [searchParams] = useSearchParams();
  const apartmentIdFromSlug = slug?.split("-").pop();
const referralCode = searchParams.get("ref");
 
  const encryptedPropertyId = searchParams.get("propertyId");
  const encryptedUserId = searchParams.get("userId");
 
  const decryptData = (ciphertext) => {
    try {
      const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (err) {
      return null;
    }
  };
 
  const ReffererId = encryptedUserId ? decryptData(encryptedUserId) : null;
  const apartmentId = encryptedPropertyId ? decryptData(encryptedPropertyId) : null;
 
  const [apartmentData, setApartmentData] = useState(null);
  const [loading, setLoading] = useState(true);
 
 
  const query = decodeURIComponent(location.search.slice(1));
 
  let property_code = null;
  let reffer_code = null;
 
  if (query) {
    const parts = query.split('/');
    if (parts.length === 2) {
      property_code = parts[0];
      reffer_code = parts[1];
    } else if (parts.length === 1) {
      property_code = parts[0];
    }
  }
 
 
  useEffect(() => {
  const fetchData = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    try {
      // Step 1: Get apartmentId + referrerId
      // const { data } = await api.getApartmentId(
      //   property_code || null,
      //   reffer_code || null
      // );

      // const apartmentId = data.propertyId;
      // const ReffererId = data.userId;

      // // Step 2: Map user ONLY if authenticated
      // if (
      //   isAuthenticated &&
      //   userId &&
      //   apartmentId &&
      //   ReffererId &&
      //   userId !== parseInt(ReffererId)
      // ) {
      //   const fd = new FormData();
      //   fd.append("userId", userId);
      //   fd.append("refererId", ReffererId);
      //   fd.append("apartmentId", apartmentId);

      //   await vendorApi.addProjectUserMapping(fd);
      // }

      // Step 3: Fetch apartment details
      if (apartmentIdFromSlug) {
        const response = await investorApi.getApartmentPlotsById(apartmentIdFromSlug);
        if (response.status === 200) {
          setApartmentData(response.data);
        }
      }
    } catch (err) {
      console.error(
        "ApartmentPlotsScreen error:",
        err?.response?.data || err.message || err
      );
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [apartmentIdFromSlug, referralCode, isAuthenticated, userId]);

  const layoutConfig = [
    {
      id: "ApartmentLayoutPage",
      render: () => <ApartmentLayoutPage data={apartmentData} type={3} />,
    },
    {
      id: "ApartmentLayoutPage",
      render: () => <AprtmentPlotsDetails data={apartmentData} isAuthenticated={isAuthenticated} type={4} />,
    },
    {
      id: "AprtmentPlotsOverview",
      render: () => <AprtmentPlotsOverview data={apartmentData} type={5} />,
    },
 
 
  ];
 
  return (
    <ScreenContainer>
      {loading ? (
        <Loader />
      ) : (
        <div style={styles.sectionWrapper}>
          {layoutConfig.map((section) => (
            <div
              key={section.id}
              style={{ backgroundColor: theme.background, ...styles.section }}
            >
              {section.render()}
            </div>
          ))}
        </div>
      )}
    </ScreenContainer>
  );
 
};
 
const styles = {
  container: {
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    // padding: "10px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
 
  },
  heading: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "24px",
    color: "#333",
 
  },
  loadingText: {
    fontSize: "16px",
    color: "#555",
    textAlign: "center",
    marginTop: "40px",
 
  },
  sectionWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    padding: "5px 20px",
 
  },
};
 
export default ApartmentPlotsScreen;